import React from 'react';
import { useTranslation } from 'react-i18next';

const CallToAction = () => {
  const { t } = useTranslation();
  return (
    <section
      className="py-20 bg-[#659088]"
    >
      <div className="container mx-auto px-4">
        <div className="text-center">
          <div className="animate-fadeIn">
            <div className="mb-6">
              <h4 className="text-white !leading-tight text-xl md:text-5xl font-semibold uppercase ">
                {t('cta.title')}
                <br />
                {t('cta.subtitle')}
              </h4>
            </div>
            <div>
              <a
                href="#"
                className="inline-block bg-yellow-500 text-white font-semibold px-6 py-3 rounded-[100px] hover:bg-yellow-600 transition"
              >
                {t('cta.button')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
